import { isUndefined } from 'lodash';
import axiosInstance, { getRequest, postRequest } from 'src/utils/axios';
import logger from 'src/utils/logger';
import parse from 'src/utils/parse';

class ProjectApi {
  async getAllAutocomplete(search: string, maxRecords: number): Promise<any> {
    return new Promise((resolve, reject) => {
      const successFunction = (response) => {
        response = parse(response);
        if (!isUndefined(response?.data)) {
          resolve(response);
        }
      };
      const errorFunction = (error) => {
        logger(error, 'error');
        reject(error);
      };
      const customHeader = {
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };
      const payload = {
        search,
        maxRecords,
      };
      const data = {
        url: `${process.env.REACT_APP_TICKETING_PROJECT_URL}/get-all-autocomplete`,
        payload,
        successFunction,
        errorFunction,
        customHeader,
      };
      postRequest(data);
    });
  }

  async syncAllProjects(): Promise<any> {
    return new Promise((resolve, reject) => {
      const successFunction = (response) => {
        response = parse(response);
        if (!isUndefined(response?.data)) {
          resolve(response);
        }
      };
      const errorFunction = (error) => {
        logger(error, 'error');
        reject(error);
      };
      const customHeader = {
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };
      const data = {
        url: `${process.env.REACT_APP_TICKETING_PROJECT_URL}/sync-projects`,
        successFunction,
        errorFunction,
        customHeader,
      };
      getRequest(data);
    });
  }

  async syncProjectCategories(): Promise<any> {
    return new Promise((resolve, reject) => {
      const successFunction = (response) => {
        response = parse(response);
        if (!isUndefined(response?.data)) {
          resolve(response);
        }
      };
      const errorFunction = (error) => {
        logger(error, 'error');
        reject(error);
      };
      const customHeader = {
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };
      const data = {
        url: `${process.env.REACT_APP_TICKETING_PROJECT_URL}/sync-project-categories`,
        successFunction,
        errorFunction,
        customHeader,
      };
      getRequest(data);
    });
  }

  async getProjectDetailsById(projectId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`${process.env.REACT_APP_CASES}/project/${projectId}`)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error: Error) => {
          logger(error, 'error');
          reject(new Error('internal Server Error'));
        });
    });
  }

  async getAllProjects(): Promise<any> {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`${process.env.REACT_APP_CASES}/project?pageSize=500`)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          } else {
            reject(new Error('internal Server Error'));
          }
        })
        .catch((error: Error) => {
          logger(error, 'error');
          reject(new Error('internal Server Error'));
        });
    });
  }

  async getJiraProjects(platformId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(
          `${process.env.REACT_APP_CASES}/auto-complete/projects/third-party?platformId=${platformId}`
        )
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          }
        })
        .catch((error: Error) => {
          reject(error);
        });
    });
  }

  async getPlatforms(): Promise<any> {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`${process.env.REACT_APP_CASES}/auto-complete/platform`)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          }
        })
        .catch((error: Error) => {
          reject(error);
        });
    });
  }

  async getStakeSponserByProject(projectId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(
          `${process.env.REACT_APP_CASES}/auto-complete/projects/sponsor-stakeholder/${projectId}`
        )
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          }
        })
        .catch((error: Error) => {
          reject(error);
        });
    });
  }

  async updateProjectById(projectId: string, payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      axiosInstance
        .put(`${process.env.REACT_APP_CASES}/project/${projectId}`, payload)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          }
        })
        .catch((error: Error) => {
          reject(error);
        });
    });
  }

  async getUsersByProj({
    organizationId,
  }: {
    organizationId: string;
  }): Promise<any> {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`${process.env.REACT_APP_CASES}/auto-complete/users`, {
          params: {
            organizationId,
          },
        })
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async getInternalUsersByProj(): Promise<any> {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`${process.env.REACT_APP_CASES}/auto-complete/users`, {
          params: {
            isExternal: false,
          },
        })
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async getAllUsers(): Promise<any> {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`${process.env.REACT_APP_CASES}/auto-complete/users`)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async changeProjectVisibility(projectId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      axiosInstance
        .patch(`${process.env.REACT_APP_CASES}/project/${projectId}/isVisible`)
        .then((response) => {
          response = parse(response);
          if (!isUndefined(response?.data)) {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export const projectApi = new ProjectApi();
